<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Headline</h3>
    {{kurzWetterbericht?.headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{kurzWetterbericht?.caption_wx_heute}}</h3>
    {{kurzWetterbericht?.wx_heute}}
  </div>
  <div class="bericht-text-container">
    <h3>{{kurzWetterbericht?.caption_wx_nacht}}</h3>
    {{kurzWetterbericht?.wx_nacht}}
  </div>
  <div class="bericht-text-container">
    <h3>{{kurzWetterbericht?.caption_wx_next_days}}</h3>
    {{kurzWetterbericht?.wx_next_days}}
  </div>
  <div class="bericht-text-container">
    {{kurzWetterbericht?.footer}}
  </div>
</div>
